import { LocalLibrary, LocalLibraryOutlined } from '@mui/icons-material'
import React from 'react'
import { useIntl } from 'react-intl'
import paths from '@app/src/wf-constants/paths'
import NavbarMenuItem from './LegacyNavbarMenuItem'

const SustainabilityLibraryMenuItem: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <NavbarMenuItem
      path={paths.sustainabilityLibrary}
      title={formatMessage({ id: 'configurations.sustainabilityLibrary' })}
      icon={LocalLibraryOutlined}
      iconSelected={LocalLibrary}
    />
  )
}

export default SustainabilityLibraryMenuItem
